// extracted by mini-css-extract-plugin
export default {"root":"booking_note_form-module___root___d8e0ac0a","button":"booking_note_form-module___button___f31811e7"};